import * as HoldersChartEntry from './holders-chart-entry'

import type { HoldersChartsDto } from '@root/shared/api/TradeApi'

export interface HoldersCharts {
  holdersCountChart: Array<HoldersChartEntry.HoldersChartEntry>
  top10HoldingChart: Array<HoldersChartEntry.HoldersChartEntry>
  insidersHoldingChart: Array<HoldersChartEntry.HoldersChartEntry>
  bundlersHoldingChart: Array<HoldersChartEntry.HoldersChartEntry>
  snipersHoldingChart: Array<HoldersChartEntry.HoldersChartEntry>
  poolCreatedAt?: Date
}

export const fromDto = (dto: HoldersChartsDto): HoldersCharts => ({
  holdersCountChart: dto.holdersCountChart.map((chart) =>
    HoldersChartEntry.fromDto(chart),
  ),
  top10HoldingChart: dto.top10HoldingChart.map((chart) =>
    HoldersChartEntry.fromDto(chart),
  ),
  insidersHoldingChart: dto.insidersHoldingChart.map((chart) =>
    HoldersChartEntry.fromDto(chart),
  ),
  bundlersHoldingChart: dto.bundlersHoldingChart.map((chart) =>
    HoldersChartEntry.fromDto(chart),
  ),
  snipersHoldingChart: dto.snipersHoldingChart.map((chart) =>
    HoldersChartEntry.fromDto(chart),
  ),
  poolCreatedAt: dto.poolCreatedAt ? new Date(dto.poolCreatedAt) : undefined,
})
